import { useTranslation } from 'react-i18next'
import { ErrorMessage } from 'components/ErrorMessage'
import { useIndividualsField } from 'hooks'
import { IndividualRoleCard } from './IndividualRoleCard'
import { IndividualModal } from './IndividualModal'

export const IndividualsField = () => {
  const { t } = useTranslation()
  const {
    modal,
    setModal,
    modalConfig,
    mainContact,
    chargebackContact,
    signer,
    openEditModal,
    onRemoveByRole,
    isSaving,
    individualsErrors
  } = useIndividualsField()

  return (
    <div className="flex flex-col gap-2">
      <IndividualRoleCard
        title={t('individuals.mainContact.title')}
        description={t('individuals.mainContact.description')}
        addLabel={t('individuals.mainContact.addButton')}
        data={mainContact}
        onEdit={() => openEditModal('mainContact')}
      />
      <ErrorMessage
        errorMessage={individualsErrors.individuals?.mainContact?.message}
      />

      <IndividualRoleCard
        title={t('individuals.chargebackContact.title')}
        description={t('individuals.chargebackContact.description')}
        addLabel={t('individuals.chargebackContact.addButton')}
        roleLabel={t('individuals.chargebackContact.title')}
        data={chargebackContact}
        onAdd={() =>
          setModal({ open: true, role: 'chargebackContact', mode: 'add' })
        }
        onEdit={() => openEditModal('chargebackContact')}
        onRemove={() => onRemoveByRole('chargebackContact')}
      />
      <ErrorMessage
        errorMessage={individualsErrors.individuals?.chargebackContact?.message}
      />

      <IndividualRoleCard
        title={t('individuals.signer.title')}
        description={t('individuals.signer.description')}
        addLabel={t('individuals.signer.addButton')}
        roleLabel={t('individuals.signer.title')}
        data={signer}
        onAdd={() => setModal({ open: true, role: 'signer', mode: 'add' })}
        onEdit={() => openEditModal('signer')}
        onRemove={() => onRemoveByRole('signer')}
      />
      <ErrorMessage
        errorMessage={individualsErrors.individuals?.signer?.message}
      />

      {modalConfig && (
        <IndividualModal
          isOpen={modal.open}
          title={modalConfig.title}
          subTitle={modalConfig.subTitle}
          submitLabel={modalConfig.submitLabel}
          config={modalConfig.config}
          defaultValues={modalConfig.defaultValues}
          isSaving={isSaving}
          onConfirm={modalConfig.onConfirm}
          onDismiss={() => setModal({ open: false })}
        />
      )}
    </div>
  )
}
